module.exports = __webpack_public_path__ + "static/media/artwork_18.a07dadb0.jpg";